import { MenuDataItem } from '@/components/Layout';
import { createContext } from 'react';

export type RouteContextType = {
  isMobile?: boolean;
  menuData?: MenuDataItem[];
  matchMenus?: MenuDataItem[];
  matchMenuKeys?: string[];
};

export const RouteContext: React.Context<RouteContextType> = createContext({});
